import { Attr, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';

@Model()
export default class PlatformActivity extends ApplicationRecord {
  static jsonapiType = 'platform_activities';

  @Attr() activeUsersLast30m: number;
  @Attr() activeUsersLast24h: number;
}
